import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

interface SchemaData {
  [key: string]: {
    '@context': string;
    '@type': string;
    [propName: string]: any;
  };
}
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  meta_title = this.translate.instant('meta_datas.home.meta_title');
  meta_description = this.translate.instant('meta_datas.home.meta_description');

  schema_data: SchemaData = {
    website: {
      '@context': 'http://schema.org',
      '@type': 'Website',
      url: 'https://phantom-theme.fr',
    },
    organization: {
      '@context': 'http://schema.org',
      '@type': 'Organization',
      name: 'Phantom Thème',
      url: 'https://phantom-theme.fr',
      logo: 'https://cdn.shopify.com/s/files/1/0532/4226/5770/files/logo-phantom-header.png?v=1657057852',
      image:
        'https://cdn.shopify.com/s/files/1/0532/4226/5770/files/logo-phantom-header.png?v=1657057852',
      sameAs: [
        'https://www.linkedin.com/company/phantom-theme',
        'https://www.youtube.com/channel/UCZIozf0LRFGlGE3aGTKyXYA',
        'https://discord.com/invite/rwcrdHkHsQ',
        'https://www.facebook.com/groups/617739035570988',
        'https://twitter.com/phantom_theme',
        'https://www.instagram.com/phantom.theme/?hl=fr',
      ],
      description: this.meta_description,
      reviews: {
        '@type': 'AggregateRating',
        ratingValue: '4.7',
        reviewCount: '46',
      },
    },
  };

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    for (const key in this.schema_data) {
      if (Object.prototype.hasOwnProperty.call(this.schema_data, key)) {
        const element = this.schema_data[key];
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = `${key}Schema`;
        script.text = JSON.stringify(element);
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  }
}
